<script>
export default {
  name: 'DocumentModal',
  props:[
    "data"
  ],
  data() {
    return {
        title:'',
        src:'',
    };
  },
  watch:{
    data(props){
       this.title = props.title
       this.src = props.src
    }
  },
  methods: {
    close(){
      this.$bvModal.hide('document_modal')
    }
  },
};
</script>

<template>
<b-modal id="document_modal" size="lg" :title="title" hide-footer style="padding:0px">
    <div class="row">
        <div class="col-12">
            <iframe :src="src" frameborder="0" style="padding:0px;width:100%;height:500px"></iframe>
        </div>
    </div>
</b-modal>
</template>